import { BaseReq, PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";

export class RoleReq extends BaseReq {
  name: string = ""; // 类型名称
  description: string = ""; // 角色描述
  belongSystem: string | number = 1; // 所属系统
}

export class RolePageReq extends PaginationReq {
  roleName: string = "";
  belongSystem: string | number = 1;
}

export class RolePageRecord extends UpdaterResp {
  id: string = ""; // 数据库ID
  name: string = ""; // 类型名称
  description: string = ""; // 角色描述
}

export class RolePageResp extends PaginationResp<RolePageRecord> {}

class RoleSimpleListRecord {
  id: string = "";
  name: string = "";
}

export class RoleSimpleListResp {
  records: RoleSimpleListRecord[];
}

export class RoleDetailResp {
  id: string = ""; // 数据库ID
  name: string = ""; // 类型名称
  description: string = ""; // 角色描述
}

export class RolePermissionReq extends BaseReq {
  menuIds: string[] = [];
}

export class RolePermissionRecord {
  menuId: string = "";
  roleId: string = "";
  tenantId: string = "";
}

export class RolePermissionDetailResp {
  records: RolePermissionRecord[] = [];
}
